export const DEFAULT_PAGE_SIZE = 10;

export const PAGE_SIZE_OPTIONS = [5, 10, 25, 50];

export const TAKE_DEFAULT = 30;
export const PAGE_DEFAULT = 1;
